import { Injectable } from "@angular/core";
import { TokenStorageService } from "../../core/services/token-storage.service";
import { ToastifyService } from "../../shared/toastify-service";
import { Router } from "@angular/router";
import { GenericService } from "../../core/services/generic.service";
import { fetchArchiveDataList, fetchArchiveDataListFailure, fetchArchiveDataListSuccess, updateArchiveRecordData, updateArchiveRecordDataFailure, updateArchiveRecordDataSuccess } from "./archive.actions";
import { ArchiveService } from "../../core/services/archive.service";
import { of, mergeMap } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

import { Actions, createEffect, ofType } from "@ngrx/effects";

@Injectable()
export class ArchiveEffects {

    /**
   * Archive List
   */
    fetchArchiveDataList$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchArchiveDataList),
            mergeMap(({ limit, skip }) =>
                this.archiveservice.getArchivedData(skip, limit).pipe(
                    map((archiveList) => {
                        return fetchArchiveDataListSuccess({ archiveList });
                    }),
                    catchError((error) =>
                        of(fetchArchiveDataListFailure({ error }))
                    )
                )
            ),
        ),
    );

    fetchArchiveDataListFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(fetchArchiveDataListFailure),
                tap((error: any) => {
                    console.log('error', error);
                    this.toastifyService.showErrorMessage(error.error.message);
                })
            ),
        { dispatch: false }
    );

    /** */
    /**
   * Update Archive Data
   */
    updateArchiveRecordData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(updateArchiveRecordData),
            mergeMap(({ recordid, postdata }) =>
                this.archiveservice.updateArchiveRecord(recordid, postdata).pipe(
                    map((archivedata:any) => {
                        return updateArchiveRecordDataSuccess({ archivedata });
                    }),
                    catchError((error) =>
                        of(updateArchiveRecordDataFailure({ error }))
                    )
                )
            ),
        ),
    );

    constructor(
        private actions$: Actions,
        private tokenService: TokenStorageService,
        private toastifyService: ToastifyService,
        private router: Router,
        private genericService: GenericService,
        private archiveservice: ArchiveService
    ) {
    }
}